module.exports = ".content {\r\n    background-color: #e8f1f2;\r\n    margin-bottom: 20px;\r\n    color: #13293d;\r\n    padding: 20px;\r\n}\r\n\r\n.label {\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n    font-size: 14px;\r\n    line-height: 1.42857143;\r\n    color: #333;\r\n    margin-left: 0px;\r\n    padding-left: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/votelocation-detail/vote-location-detail.component.css
// module id = ./src/app/components/votelocation-detail/vote-location-detail.component.css
// module chunks = main